import { createFileRoute } from '@tanstack/react-router'
import BlogPage from '../../landing/BlogPage'

export const Route = createFileRoute('/blog/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <BlogPage />
}
